import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "keyboard-arrow-right",
  "use": "keyboard-arrow-right-usage",
  "viewBox": "0 0 768 768",
  "content": "<symbol viewBox=\"0 0 768 768\" id=\"keyboard-arrow-right\"><path d=\"M274.5 523.5l147-147-147-147 45-45 192 192-192 192z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/keyboard-arrow-right.svg
// module id = 5+wT
// module chunks = 1